module.exports = __webpack_public_path__ + "static/apple-icon-152x152-86b56aac398569bf725e8283b8b0b8c0.png";